<div class="table-responsive rounded border" style="background: #ffffff; border-color: #e2e8f0 !important;" *ngIf="TatReportsList">
  <table class="table table-hover table-striped mb-0" style="font-size: 0.8125rem;">
    <thead style="background: var(--theme-primary, #123c53); color: #ffffff;">
      <tr>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Process</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Executive</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Status</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Assign On</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Completed On</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">TAT (Hrs)</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Remark</th>
        <th class="py-2 text-uppercase font-weight-bold text-center" style="font-size: 0.75rem; letter-spacing: 0.5px;">Location</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of TatReportsList">
        <td class="font-weight-bold text-dark">{{ row.Process }}</td>
        <td class="text-dark">{{ row.ProcessExecutive }}</td>
        <td>
          <span class="badge px-2 py-1" [ngClass]="{
            'badge-success': row.ProcessStatus == 'Completed',
            'badge-warning': row.ProcessStatus == 'Pending',
            'badge-danger': row.ProcessStatus == 'Rejected' || row.ProcessStatus == 'Sendback',
            'badge-secondary': row.ProcessStatus != 'Completed' && row.ProcessStatus != 'Pending' && row.ProcessStatus != 'Rejected' && row.ProcessStatus != 'Sendback'
          }">{{ row.ProcessStatus }}</span>
        </td>
        <td class="text-dark">{{ row.AssignedOn }}</td>
        <td class="text-dark">{{ row.CompletedOn }}</td>
        <td class="font-weight-bold text-info">{{ row.TAT_Hr }}</td>
        <td class="text-muted small" style="white-space: normal !important; word-break: break-word !important; min-width: 160px;" [title]="row.Remark">{{ row.Remark || '-' }}</td>

        <td class="text-center">
          <a
            target="_blank"
            class="btn btn-sm btn-outline-danger py-0 px-2 font-size-11"
            *ngIf="row.LatLong != '' && row.LatLong != null && row.LatLong != ','"
            [href]="'http://maps.google.com/maps?q=' + row.LatLong"
            title="View Location on Map"
          >
            <i class="fas fa-map-marker-alt"></i> Map
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
